import React, { FC } from "react";
import { ApplePayPayload } from "braintree-web";
import { Heading } from "@pepdirect/v3/ui/Heading";
import { StyledNewApplePayText, StyledSpinner } from "./index.styled";
import { ApplePayButton } from "../ApplePayButton";
import useApplePay from "v3/hooks/useApplePay";
import {
  CheckoutSessionFragment,
  useTenantQuery,
} from "v3/services/graphql/generated";

interface ApplePayPaymentProps {
  onApprove?: (data: ApplePayPayload) => Promise<void>;
  tokenizeDetails: ApplePayPayload | null;
  checkoutSession: CheckoutSessionFragment;
}

export const ApplePayPayment: FC<ApplePayPaymentProps> = ({
  onApprove,
  tokenizeDetails,
  checkoutSession,
}) => {
  const { data, loading } = useTenantQuery();
  const { createPaymentRequest } = useApplePay({
    onApprove,
    checkoutSession,
    title: data?.tenant?.brandConfig?.title || "",
  });
  return (
    <>
      {tokenizeDetails ? (
        <>
          <Heading size="xs" level="h3">
            Apple Pay Details Accepted
          </Heading>
          <StyledNewApplePayText>
            Click the button below to review and place your order.
          </StyledNewApplePayText>
        </>
      ) : (
        <>
          <Heading size="xs" level="h3">
            Pay with Apple Pay
          </Heading>
          <StyledNewApplePayText>
            You&apos;ll be taken to Apple Pay to enter payment details, and will
            return here to finalize your order.
          </StyledNewApplePayText>
          {loading && <StyledSpinner />}
          {!loading && <ApplePayButton onClick={createPaymentRequest} />}
        </>
      )}
    </>
  );
};
